module.exports = __webpack_public_path__ + "img/full_footer.c4c74f65.jpg";